import { render, staticRenderFns } from "./sequences-tab.vue?vue&type=template&id=5f0cee35"
import script from "./sequences-tab.vue?vue&type=script&lang=js"
export * from "./sequences-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports